import template from './main-table-header-col.html';

export default angular.module('gm.wealth.common')
  .directive('gmwMainTableHeaderCol', gmwMainTableHeaderCol)
  .name;

function gmwMainTableHeaderCol() {
  'ngInject';

  const directive = {
    link,
    replace: true,
    require: ['^gmwMainTableHeader', '^?ngModel'],
    restrict: 'E',
    template,
    scope: {
      tooltip: '@?',
    },
    transclude: true,
  };
  return directive;

  function link(scope, _element, $attrs, ctrls) {
    const field = $attrs.field;
    const [ctrl, ngModel] = ctrls;

    function changeSorting() {
      if (field) {
        ctrl.setSorting(field);
      }
    }

    scope.changeSorting = changeSorting;
    scope.hasField = !!field;
    scope.model = ngModel;

    scope.$watch('model.$modelValue', (value) => {
      if (value && value.field === field) {
        scope.sortingDirection = value.type;
      } else {
        scope.sortingDirection = undefined;
      }
    }, true);
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/directives/main-table-header-col/main-table-header-col.js